import React from "react";
import { FieldFeedbackLabel } from "./FieldFeedbackLabel";

const getFieldCSSClasses = (touched, errors) => {
  const classes = ["form-control"];
  if (touched && errors) {
    classes.push("is-invalid");
  }

  if (touched && !errors) {
    classes.push("is-valid");
  }

  return classes.join(" ");
};

export function Input({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors }, // also values, set, handle, dirty, isValid, status, etc.
  label,
  withFeedbackLabel = true,
  customFeedbackLabel,
  type = "text",
  min,
  ...props
}) {

  // console.log("Input props :")
  // console.log(touched)
  // console.log(errors)

  return (
    <>
      {/* {label && <label>Enter {label}</label>} */}
      {label && <label>{label}</label>}
      <input
        type={type}
        min={min}
        className={getFieldCSSClasses(touched[field.name], errors[field.name])}
        // className={`form-control form-control-lg form-control-solid ${getFieldCSSClasses(touched[field.name], errors[field.name])}`}
        {...field}
        {...props}
      />
      {withFeedbackLabel && (
        <FieldFeedbackLabel
          error={errors[field.name]}
          touched={touched[field.name]}
          label={label}
          type={type}
          customFeedbackLabel={customFeedbackLabel}
        />
      )}
    </>
  );
}
